import { AnswerContent } from '..'

export function detectVideoTouch(
  content: AnswerContent
): content is AnswerContent & { meta: { type: 'video:video-touch' } } {
  return content.meta?.type === 'video:video-touch'
}

export function getEmbedUrlForId(id: string | null): string {
  if (!id) return ''
  return `https://video-touch.com/video/${id}/embed`
}
